function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var SHA256 = require('crypto-js/sha256');

var _isDomReady = false,
    loadedScripts = new Set();

var _ctx = getGlobal();

var isBrowser = _ctx && _ctx === _ctx.window;
var isLocalhost = isBrowser && ['localhost', '127.0.0.1', ''].indexOf(_ctx.location.hostname.toLowerCase()) !== -1;
function scriptExists(scriptMap) {
  var scripts = _ctx.document.scripts;
  var targetScripts = flattenScripts(scriptMap).map(function (ts) {
    return ts.toLowerCase();
  });
  var found = false;

  if (scripts) {
    for (var i = 0; i < scripts.length; i++) {
      var src = scripts[i].src;

      if (src && targetScripts.indexOf(src.toLowerCase()) !== -1) {
        found = true;
        break;
      }
    }
  }

  return found;
}
function onDomReady() {
  return new Promise(function (resolve, reject) {
    if (!isBrowser) return reject(new Error('Attempt to invoke dom functionality in a non-browser environment.'));
    if (_isDomReady || document.readyState === 'complete') return resolve();
    document.addEventListener('DOMContentLoaded', function () {
      _isDomReady = true;
      resolve();
    });
  });
}
function injectScript(script) {
  var src = script.src,
      integrity = script.integrity,
      _script$crossOrigin = script.crossOrigin,
      crossOrigin = _script$crossOrigin === void 0 ? 'anonymous' : _script$crossOrigin;
  return new Promise(function (resolve, reject) {
    if (!isBrowser) {
      return reject(new Error('Attempt to invoke dom functionality in a non-browser environment.'));
    }

    if (loadedScripts.has(src)) {
      return resolve();
    }

    var loaded = function loaded() {
      loadedScripts.add(src);
      resolve();
    };

    var failed = function failed(err) {
      reject(err);
    };

    var script = _ctx.document.createElement('script');

    script.src = src;
    script.type = 'text/javascript';
    script.async = true;
    script.onload = loaded;
    script.onerror = failed;

    if (integrity) {
      script.integrity = integrity;
      script.crossOrigin = crossOrigin;
    }

    document.head.appendChild(script);
  });
}
/**
 *
 * @param fns functions to pipe (left -> right)
 */

function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  function invoke(val) {
    var _this = this;

    return fns.reduce(function (acc, fn) {
      return fn ? fn.call(_this, acc) : acc;
    }, val);
  }

  return invoke;
}
/**
 * Memoize function call for fn that accepts one string argument
 */

function memo1(fn, checkResult) {
  var cache = new Map();

  function wrapper(arg) {
    if (cache.has(arg)) return cache.get(arg);
    var res = fn.call(this, arg);
    if (!checkResult || checkResult(res)) cache.set(arg, res);
    return res;
  }

  return wrapper;
}
function flatten1(arr) {
  return arr.reduce(function (acc, cur) {
    if (Array.isArray(cur)) acc.push.apply(acc, cur);else acc.push(cur);
    return acc;
  }, []);
}

function flattenScripts(scriptMap) {
  return Object.keys(scriptMap).reduce(function (acc, key) {
    var srcs = scriptMap[key].map(function (s) {
      return s.src;
    });
    acc.push.apply(acc, srcs);
    return acc;
  }, []);
}

var _localhostTrackingKey = '__localhostTracking__';
var _localhostTracking = {
  on: function on() {
    return _ctx.sessionStorage.setItem(_localhostTrackingKey, true);
  },
  status: function status() {
    return _ctx.sessionStorage.getItem(_localhostTrackingKey);
  },
  clear: function clear() {
    return _ctx.sessionStorage.removeItem(_localhostTrackingKey);
  }
};
var isLocalhostTrackingEnabled = function isLocalhostTrackingEnabled() {
  return !!_localhostTracking.status();
};

(function selfRegister() {
  if (isBrowser && isLocalhost) {
    onDomReady().then(function () {
      if (!isLocalhostTrackingEnabled()) {
        console.warn("Hello CORNERSTONE DEVELOPER. In order to enable analytics tracking on " + _ctx.location.hostname + ", enter the following code into your browser's javascript console and reload page: window.localhostTracking.on()");
      }

      _ctx.localhostTracking = _localhostTracking;
    });
  }
})();

function digest(msg) {
  return SHA256(msg).toString().toUpperCase();
}
function hashUserData(userData, keys) {
  if (keys === void 0) {
    keys = ['userId'];
  }

  keys = keys.filter(function (key) {
    return userData.hasOwnProperty(key);
  });
  if (keys.length === 0) return Promise.resolve(userData);
  return Promise.all(keys.map(function (key) {
    return digest("" + userData[key]);
  })).then(function (hashed) {
    return hashed.reduce(function (acc, val, i) {
      acc[keys[i]] = val;
      return acc;
    }, _objectSpread({}, userData));
  });
}
/**** internal helpers ****/
// globalThis: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis

function getGlobal() {
  if (typeof self !== 'undefined') {
    return self;
  }

  if (typeof window !== 'undefined') {
    return window;
  }

  if (typeof global !== 'undefined') {
    return global;
  }

  throw new Error('unable to locate global object');
}

export { isBrowser, isLocalhost, scriptExists, onDomReady, injectScript, pipe, memo1, flatten1, isLocalhostTrackingEnabled, digest, hashUserData };



//////////////////
// WEBPACK FOOTER
// ../@csod/tracker-common/build/index.js
// module id = 597
// module chunks = 0